import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-3" }
const _hoisted_2 = ["onClick"]

import { useWorkflowStore } from "@/stores/workflow"
import { convertTriggerEvent } from "@/shared/utils/helpers"
import TriggerCard from "@/components/workflows/TriggerCard.vue"
import { ListingActivityTriggerNodeType, NodeType } from "@/shared/models/workflow"
import EventOccurrenceNode from "@/components/workflows/EventOccurrenceNode.vue"
import PageVisitedFilterDelaySidebar from "@/components/workflows/sidebar/action/delay/PageVisitedFilterDelaySidebar.vue"

interface Props {
    modelValue: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'EventOccurrenceComponent',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "changeAction"],
  setup(__props: any, { emit: __emit }) {

const workflowStore = useWorkflowStore()

const events = [
    {
        title: ListingActivityTriggerNodeType.pageVisited,
        example: "Delays until a contact loads or navigates to a specified page or URL on your site.",
    },
    {
        title: ListingActivityTriggerNodeType.requestForInformation,
        example: "Delays until a contact submits a “Request Info” form on any listing.",
    },
    {
        title: ListingActivityTriggerNodeType.showingRequest,
        example: "Delays until a contact schedules or attempts to schedule a property showing.",
    },
    {
        title: ListingActivityTriggerNodeType.saveListing,
        example: "Delays until a contact adds a listing to their Saved collection.",
    },
    {
        title: ListingActivityTriggerNodeType.favoriteListing,
        example: "Delays until a contact adds a listing to their Favorites collection.",
    },
    {
        title: ListingActivityTriggerNodeType.hideListing,
        example: "Delays until a contact hides or dismisses a listing from their search results.",
    },
]



const emit = __emit

function chooseEvent(event: string) {
    workflowStore.modelValue = event
    if (event === ListingActivityTriggerNodeType.pageVisited) {
        emit("changeAction", { componentName: PageVisitedFilterDelaySidebar.__name })
        return
    }
    emit("changeAction", { componentName: EventOccurrenceNode.__name, node: NodeType.eventOccurrence })
    workflowStore.setHeaderText()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(events, (event) => {
      return _createElementVNode("div", {
        key: event,
        class: "text-gray-900 text-base leading-6 font-medium cursor-pointer",
        onClick: ($event: any) => (chooseEvent(event.title))
      }, [
        _createVNode(TriggerCard, {
          title: _unref(convertTriggerEvent)(event.title),
          example: event.example,
          onClick: ($event: any) => (chooseEvent(event.title))
        }, null, 8, ["title", "example", "onClick"])
      ], 8, _hoisted_2)
    }), 64))
  ]))
}
}

})